import { motion } from "framer-motion";
import { Burst, Flag } from "@/components/home/Doodles";
import { PHOTOS, Photo } from "@/components/home/photos";
import { QuoteAccent, CtaButton } from "@/components/home/HeroSection";

const STEPS = [
  { t: "Kennismaken", d: "Een veilige start met aandacht voor jouw verhaal." },
  { t: "Ontdekken", d: "Inzicht in je talenten, drijfveren en mogelijkheden." },
  { t: "Ontwikkelen", d: "Nieuwe ervaringen, praktische oefeningen en stappen zetten." },
  { t: "Verdergaan", d: "Een passende volgende stap richting bijvoorbeeld werk, dagbesteding of andere participatie." },
];

export function ProgramSteps() {
  return (
    <div className="relative rounded-[28px] bg-white/80 border border-ll-forest/10 p-6 sm:p-8 h-full" data-testid="home-start-steps">
      <Burst className="absolute top-5 right-5 w-7 h-7 text-ll-orange" />
      <p className="font-heading font-semibold text-xl text-ll-forest">De START-reis in het kort</p>
      <ol className="mt-6 space-y-5">
        {STEPS.map((s, i) => (
          <motion.li key={s.t} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }} className="flex gap-4">
            <span className="shrink-0 w-9 h-9 rounded-full bg-ll-peach text-ll-forest font-heading font-semibold flex items-center justify-center">{i + 1}</span>
            <div>
              <p className="font-semibold text-ll-forest">{s.t}</p>
              <p className="text-sm text-ll-ink/75 leading-relaxed">{s.d}</p>
            </div>
          </motion.li>
        ))}
      </ol>
      <Flag className="absolute right-6 bottom-4 w-10 h-14 text-ll-forest/70 hidden sm:block" />
    </div>
  );
}

export default function StartSection() {
  return (
    <section className="bg-ll-cream py-6 sm:py-10" data-testid="home-start">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-6">
        <div className="relative lg:col-span-4 min-h-[300px] sm:min-h-[380px] rounded-[28px] overflow-hidden lift">
          <Photo photo={PHOTOS.uitzicht} sizes="(min-width:1024px) 33vw, 100vw" className="absolute inset-0 w-full h-full" />
          <QuoteAccent className="absolute top-6 right-5 text-3xl sm:text-4xl max-w-[220px] text-ll-forest bg-ll-cream/70 rounded-2xl px-3 py-2" lineClass="w-28">
            “Speelruimte om te ontdekken wat wél werkt.”
          </QuoteAccent>
        </div>
        <div className="lg:col-span-4 flex flex-col justify-center py-4 lg:px-4">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-ll-ink/70">Het START-programma</p>
          <h2 className="mt-4 font-heading font-semibold text-4xl sm:text-5xl leading-[1.02] tracking-tight text-ll-forest">De START-reis in twaalf weken</h2>
          <p className="mt-5 text-ll-ink/85 leading-relaxed">
            Een praktisch en persoonlijk ontwikkelprogramma voor mensen die al langere tijd vastlopen.
          </p>
          <p className="mt-3 text-ll-ink/85 leading-relaxed">
            In een vaste, intensief begeleide groep (20–22 deelnemers, 2 trainers) ontdekken deelnemers nieuwe mogelijkheden, oefenen ze met persoonlijke ontwikkeling en werken ze aan passende vervolgstappen.
          </p>
          <div className="mt-7">
            <CtaButton to="/programma" variant="forest" testid="home-start-cta">Ontdek hoe het START-programma werkt</CtaButton>
          </div>
        </div>
        <div className="lg:col-span-4"><ProgramSteps /></div>
      </div>
    </section>
  );
}
